class CartToggleCount extends HTMLElement {
  constructor() {
    super();
    this.updateCartCount = this.updateCartCount.bind(this);
  }

  connectedCallback() {
    // Use session storage for faster load on back navigation
    const savedCartCount = sessionStorage.getItem('cartItemCount');

    if (savedCartCount !== null) {
      // Set the cart count immediately from session storage to avoid flashes
      this.textContent = savedCartCount;
    }

    // Always trigger a fresh fetch to ensure accuracy
    this.updateCartCount();

    // Update cart count when the page is shown (including navigating back)
    window.addEventListener('pageshow', (event) => {
      // If the page was restored from bfcache (back/forward cache), force update
      if (event.persisted) {
        this.updateCartCount(); // Fetch fresh cart count even when using the back button
      }
      this.updateCartCount();
    });

    // Fallback: Update cart count on initial load
    window.addEventListener('load', this.updateCartCount);
  }

  disconnectedCallback() {
    // Clean up event listeners to avoid memory leaks
    window.removeEventListener('load', this.updateCartCount);
    window.removeEventListener('pageshow', this.updateCartCount);
  }

  updateCartCount() {
    let cartUrl = window.Shopify.routes.root + 'cart.js';

    fetch(cartUrl)
      .then(response => response.json())
      .then(data => {
        const cartCount = data.item_count;

        // Update the cart count only if it has changed
        if (this.textContent != cartCount) {
          this.textContent = cartCount;

          // Update all elements with data-items-count attribute
          [...document.querySelectorAll('[data-items-count]')].forEach((item) => {
            item.innerHTML = cartCount;
          });
        }

        // Save the updated cart count to session storage for future navigations
        sessionStorage.setItem('cartItemCount', cartCount);
      })
      .catch(error => {
        console.error('Error updating cart count:', error);
      });
  }
}

customElements.define('cart-toggle-count', CartToggleCount);
